import { Properties, PropertyItem } from "./ShipBayPlan";

export enum AttributeType {
	_45ft = "45ft",
	Blocked = "blocked",
	Reefer = "reefer",
	Vertical = "vertical"
}

const ATTRIBUTE_COLORS: Record<AttributeType, string> = {
	[AttributeType._45ft]: "#4dcf5c",
	[AttributeType.Blocked]: "#c8333c",
	[AttributeType.Reefer]: "#1c65a9",
	[AttributeType.Vertical]: "#793ebb",
};

export function getAttributeColor(type: AttributeType): string {
	return ATTRIBUTE_COLORS[type];
}

export const convertPropertiesToList = (properties: Properties | null) => {

	const items = [] as PropertyItem[];

	if (properties) {
		properties.forEach(it => {
			Object.keys(it).forEach((key) => {
				if (key !== "tier") {
					if (it[key as AttributeType]) {
						Object.keys(it[key as AttributeType] as object).forEach(row => {
							if (Array.isArray(it[key as AttributeType]?.[row])) {
								it[key as AttributeType]?.[row].forEach((bay: number) => {
									items.push({
										tier: it.tier,
										row: Number(row),
										bay: bay,
										attribute: key as AttributeType,
									});
								});
							}
						});
					}
				}
			});
		});
	}

	return items;
};

export const convertPropertiesListToFormData = (properties: PropertyItem[]) => {

	const list = [] as Properties;

	properties.forEach((item) => {

		const hasTier = list.find(it => it.tier === item.tier);

		if (hasTier) {

			const tierIndex = list.findIndex(it => it.tier === item.tier);
			const hasAttribute = list[tierIndex][item.attribute];

			if (hasAttribute) {

				const hasRow = list[tierIndex][item.attribute]?.[item.row];
				const attributeObject = list[tierIndex][item.attribute] || {};
				const bays = list[tierIndex][item.attribute]?.[item.row] || [];

				list[tierIndex][item.attribute] = {
					...attributeObject,
					[item.row]: hasRow ? [ ...bays, item.bay ] : [ item.bay ],
				};

			} else {

				list[tierIndex][item.attribute] = {
					[item.row]: [ item.bay ],
				};
			}
		} else {

			list.push({
				tier: item.tier,
				[item.attribute]: {
					[item.row]: [ item.bay ],
				},
			});
		}
	});

	return list;
};

export const getRowNumber = (rows: number, rowIndex: number) => {

	const isEven = (n: number) => n % 2 == 0;
	let numbers = [ ...Array.from(Array(rows).keys()) ];

	//00 should not show up when there are an even number of rows
	if (rows % 2 == 0) {
		numbers = numbers.map(n => n + 1);
	}

	const evenNumbers = [ ...numbers.filter(n => isEven(n)) ].sort().reverse();
	const oddNumbers = [ ...numbers.filter(n => !isEven(n)) ].sort();
	const list = [ ...evenNumbers, ...oddNumbers ];
	return list[rowIndex];
};
